import React from 'react';
import axios from 'axios';
import HeaderNews from './HeaderNews';

class News extends React.Component {

	constructor(props){
		super(props);
		 // this.goBack = this.goBack.bind(this);
		this.state = {
			ak: "",
			news:[]
		}
	}

	componentDidMount(){
      const params = new URLSearchParams(this.props.location.query); 
      const value = params.get('newsId')
      // const access_token = localStorage.getItem("access_token");
      // console.log(access_token);
      

      
      //get individual news item from the api
      axios.get('https://api.indianoilxpress.com/MobService.svc/Happenings/'+value)
	    .then(({data} )=> {
	      this.setState({news:data.HappeningsResult[0]});
	      // this.setState({ak: access_token});
	    });
	}
	

	render() {
		return(

			<div>
				<HeaderNews />
		        <div className="pages section">
					<div className="container">
						<div className="blog-single">
							<img src={this.state.news.newsimagepath} alt=""/>
							<div className="blog-single-content">
								<h5>{this.state.news.Newstitle}</h5>
								<div className="byline">
									<span>{this.state.news.Byline}</span>
								</div>
								<div className="date">
									<span>{this.state.news.Newsdate}</span>
								</div>
								<p dangerouslySetInnerHTML={{	__html: this.state.news.NewsDesc}}/>
							</div>		
						</div>
					</div>	
				</div>
				

				<div className="footer">
					<div className="container">
					<div className="copyright">
							<span>Copyright © IndianOilXpress</span><br/>
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
                <a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
                <a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
				<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
				<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>
				
						</div>
					</div>
				</div>

			</div>

		)
	}
}

export default News;


// WEBPACK FOOTER //
// ./src/News.js